import {
  TextField,
  Tabs,
  Tab,
  InputAdornment,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import OFACTab from "./components/OFACTab";
import UKSanctionsTab from "./components/UKSanctionsTab";
import NonSDNTab from "./components/NonSDNTab";
import OthersTab from "./components/OthersTab";
import AddressTab from "./components/AddressTab";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../home/home.scss";
import Swal from "sweetalert2";
import FileUploadModal from "./components/FileUploadModal";
import { MdSearch } from "react-icons/md";
import ViewFilesTable from "./components/ViewFilesTable";
import {
  createImport,
  createWatchList,
  deleteImportedFileData,
  getImportedData,
} from "../../Api";
import PEPTab from "./components/PEPTab";
import WatchListTab from "./components/WatchListTab";
import { tab } from "@testing-library/user-event/dist/tab";

export const tabsData = [
  "OFAC",
  "UKSanctions",
  "NONSDN",
  // "Address",
  "PEP",
  "Watch List",
  "Negative",
  // "Address",
];

// Mapping for display labels
const tabDisplayLabels = {
  OFAC: "OFAC",
  UKSanctions: "UK Sanctions",
  NONSDN: "NON SDN",
  // Address: "Address",
  PEP: "PEP",
  "Watch List": "Watch List",
  Negative: "Negative",
};

function ImportData() {
  const navigate = useNavigate();
  const [reload, setReload] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileInputs, setFileInputs] = useState([{ id: Date.now(), files: [] }]);
  const [submittedData, setSubmittedData] = useState(
    tabsData.reduce((acc, tab) => {
      acc[tab] = [];
      return acc;
    }, {})
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [viewFilesModal, setViewFilesModal] = useState(false);
  const [modalSelectedFile, setModalSelectedFile] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [previewCurrentPage, setPreviewCurrentPage] = useState(1);
  const [previewTableData, setPreviewTableData] = useState([]);
  const [allData, setAllData] = useState([]); // Store all data for frontend pagination
  const [loading, setLoading] = useState(false);
  const [previewTotalItems, setPreviewTotalItems] = useState(0);
  const [dataFetched, setDataFetched] = useState(false); // Track if data was successfully fetched
  const [fileType, setFileType] = useState(""); // ✅ state

  const handleChange = (event) => {
    setFileType(event.target.value); // ✅ update state
  };
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  // For watch list creation
  const [name, setName] = useState("");
  // For Address tab file type selection
  const [addressFileType, setAddressFileType] = useState("OFAC_ADD_SDN");

  const itemsPerPage = 10;

  // Reset addressFileType when tab changes to Address
  useEffect(() => {
    if (tabsData[selectedTab] === "Address") {
      setAddressFileType("OFAC_ADD_SDN");
    }
  }, [selectedTab, tabsData]);

  // Function to get table headers based on file type
  const getTableHeaders = () => {
    const selectedFileType = selectedFile?.fileType;

    // Special handling for Address tab files
    if (
      selectedFileType === "OFAC_ADD_SDN" ||
      selectedFileType === "OFAC_ADD_NON_SDN"
    ) {
      return [
        "#",
        "ID",
        "ID1",
        "Address1",
        "Address2",
        "Address3",
        "Address4",
        "Postal Code1",
        "Processing Status",
      ];
    }

    // Handle other file types
    switch (tabsData[selectedTab]) {
      case "OFAC":
        return [
          "#",
          "ENT_NUM",
          "SDN_NAME",
          "SDN_TYPE",
          "PROGRAM",
          "TITLE",
          "CALL_SIGN",
          "VESSEL_TYPE",
          "TONNAGE",
          "GRT",
          "VESSEL_FLAG",
          "VESSEL_OWNER",
          "REMARKS",
        ];
      case "UKSanctions":
        return [
          "#",
          "UNIQUE_ID",
          "OFSI_GROUP_ID",
          "NAME",
          "REGIME_NAME",
          "TYPE",
          "DESIGNATION_SOURCE",
          "DATE_DESIGNATED",
          "SANCTIONS_IMPOSED",
        ];
      case "NONSDN":
        return [
          "#",
          "ENT_NUM",
          "SDN_NAME",
          "SDN_TYPE",
          "PROGRAM",
          "TITLE",
          "CALL_SIGN",
          "VESSEL_TYPE",
          "TONNAGE",
          "GRT",
          "VESSEL_FLAG",
          "VESSEL_OWNER",
          "REMARKS",
        ];
      case "Negative":
        return [
          "#",
          "UNIQUE_ID",
          "NAME",
          // filetype to type
          "TYPE",
          "LOAD_DATE",
          "LOAD_TIME",
        ];
      case "PEP":
        return [
          "#",
          "UNIQUE_ID",
          "NAME",
          // "FILE_TYPE",
          "LOAD_DATE",
          "LOAD_TIME",
        ];
      case "Watch List":
        return [
          "#",
          "UNIQUE_ID",
          "NAME",
          // "FILE_TYPE",
          "LOAD_DATE",
          "LOAD_TIME",
        ];
      case "Address":
        return [
          "#",
          "ID",
          "ID1",
          "ADDRESS1",
          "ADDRESS2",
          "ADDRESS3",
          "ADDRESS4",
          "LOAD_DATE",
          "LOAD_TIME",
        ];
      default:
        return ["#", "ID", "File Name", "Created Date", "Processing Status"];
    }
  };

  // For sorting functionality fields
  const getSortableFields = () => {
    switch (tabsData[selectedTab]) {
      case "OFAC":
        return ["ENT_NUM", "SDN_NAME", "SDN_TYPE"];
      case "UKSanctions":
        return ["UNIQUE_ID", "NAME", "TYPE"];
      case "NONSDN":
        return ["ENT_NUM", "SDN_NAME", "SDN_TYPE"];
      case "PEP":
        return ["NAME"];
      case "Watch List":
        return ["NAME"];
      case "Negative":
        return ["NAME", "TYPE"];
      default:
        return [];
    }
  };

  // sorting function
  const handleSort = (columnKey) => {
    const sortableFields = getSortableFields();
    // Normalize column key to match data keys
    const normalizedKey = columnKey.toUpperCase().replace(/\s+/g, "_");

    if (!sortableFields.includes(normalizedKey)) {
      return; // Don't sort if column is not sortable
    }

    setSortConfig((prevConfig) => {
      if (prevConfig.key === normalizedKey) {
        // Toggle direction if same column
        return {
          key: normalizedKey,
          direction: prevConfig.direction === "asc" ? "desc" : "asc",
        };
      } else {
        // New column, default to ascending
        return {
          key: normalizedKey,
          direction: "asc",
        };
      }
    });
    setPreviewCurrentPage(1); // Reset to first page when sorting
  };

  const handleTabChange = (event, newValue) => {
    // Clear selected file
    setSelectedFile(null);
    // Reset file inputs
    setFileInputs([{ id: Date.now(), files: null }]);
    // Update selected tab
    setSelectedTab(newValue);
    // Reset current page for the new tab
    setCurrentPage(1);
  };

  const handleFileChange = (id, event, fileType = null) => {
    if (event) {
      // Handle file selection
      const selectedFile = event.target.files[0];
      const updatedInputs = fileInputs.map((input) =>
        input.id === id
          ? {
              ...input,
              files: {
                ...selectedFile,
                name: selectedFile.name,
                fileType: input.files?.fileType || null,
              },
            }
          : input
      );
      setFileInputs(updatedInputs);
    } else if (fileType) {
      // Handle file type selection
      const updatedInputs = fileInputs.map((input) =>
        input.id === id
          ? {
              ...input,
              files: {
                ...input.files,
                fileType: fileType,
              },
            }
          : input
      );
      setFileInputs(updatedInputs);
    }
  };

  const [rawDataImportModal, setRawDataImportModal] = useState(false);
  const handleRawDataImportModal = () => {
    setRawDataImportModal(!rawDataImportModal);
    if (!rawDataImportModal) {
      setFileInputs([{ id: Date.now(), files: [] }]);
    }
  };

  // For delete
  const handleDeleteFile = async (file) => {
    const result = await Swal.fire({
      text: "Are you sure you want to delete the file!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });

    if (!result.isConfirmed) return;

    try {
      // Show loading
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });

      // Get effective file type based on the existing file type and tab
      const effectiveFileType = getEffectiveFileType(
        file.fileType,
        tabsData[selectedTab]
      );
      console.log("Deleting file with type:", effectiveFileType);

      // Call delete API
      const response = await deleteImportedFileData({
        file_type: effectiveFileType,
        file_name: file.file_name,
        bank_code: localStorage.getItem("bank_code") || "",
        correl_id: localStorage.getItem("correl_id") || "",
      });

      // Close loading dialog immediately
      Swal.close();

      if (response?.status === "S") {
        // Immediately clear UI state
        if (selectedFile && selectedFile.file_name === file.file_name) {
          setSelectedFile(null);
          setPreviewTableData([]);
          setPreviewCurrentPage(1);
        }

        // Reset current page and clear current tab data
        setCurrentPage(1);
        setSubmittedData((prevData) => ({
          ...prevData,
          [tabsData[selectedTab]]: [],
        }));

        // Clear addressFileType if we're on Address tab and file was deleted
        if (tabsData[selectedTab] === "Address") {
          setAddressFileType("");
        }

        // Trigger reload to refresh TabContent component
        setReload((prev) => !prev);

        // Show success message
        Swal.fire({
          text: "File deleted successfully!",
          icon: "success",
          showConfirmButton: true,
          heightAuto: false,
        });

        // Refresh data from server
        // try {
        //   const response = await getImportedFileData({
        //     file_type: effectiveFileType,
        //     bank_code: localStorage.getItem("bank_code") || "",
        //     page: 1,
        //     pageSize: itemsPerPage
        //   });

        //   if (response?.status === "S") {
        //     setSubmittedData(prevData => ({
        //       ...prevData,
        //       [tabsData[selectedTab]]: response.result_info || []
        //     }));
        //   } else {
        //     throw new Error(response?.message || "Failed to refresh data");
        //   }
        // } catch (refreshError) {
        //   console.error("Error refreshing data after deletion:", refreshError);
        //   Swal.fire({
        //     title: "Warning",
        //     text: "File was deleted but the table could not be refreshed. Please refresh the page.",
        //     icon: "warning",
        //     showConfirmButton: true
        //   });
        // }
      } else if (response?.status === "F") {
        if (
          response.message === "Unauthorized - Missing token" ||
          response.message === "Unauthorized - Invalid token"
        ) {
          await Swal.fire({
            text: "Please login with your credentials",
            icon: "warning",
            showConfirmButton: false,
            timer: 3000,
          });
          localStorage.clear();
          navigate("/login");
        } else {
          Swal.fire({
            title: "Error",
            text: response.message || "Failed to delete file",
            icon: "error",
            showConfirmButton: true,
          });
        }
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      Swal.close();
      Swal.fire({
        title: "Error",
        text: "An error occurred while deleting the file",
        icon: "error",
        showConfirmButton: true,
      });
    }
  };

  // Helper function to determine effective file type for file operations
  const getEffectiveFileType = (fileType, currentTab) => {
    // If the file already has a type, use it exactly as is
    if (fileType) {
      if (fileType === "Watch List") {
        return "WATCH_LIST";
      }

      // For non-address files
      if (!fileType.toUpperCase().includes("OFAC_ADD")) {
        return fileType;
      }

      // For address files, preserve NON_SDN vs SDN distinction
      const isNonSdn = fileType.toUpperCase().includes("NON_SDN");
      return isNonSdn ? "OFAC_ADD_NON_SDN" : "OFAC_ADD_SDN";
    }

    // If no file type is provided, determine based on tab
    switch (currentTab) {
      case "OFAC":
        return "OFAC_SDN";
      case "NONSDN":
        return "OFAC_NON_SDN";
      case "UKSanctions":
        return "UK_Sanctions";
      case "Negative":
        return "Miscellaneous";
      case "Watch List":
        return "WATCH_LIST";
      case "Address":
        // Use the selected file type from the dropdown
        return addressFileType || "";
      default:
        return currentTab;
    }
  };

  const handleViewFile = (file) => {
    console.log("this is called");
    if (!file) {
      console.error("No file data provided");
      return;
    }
    setPreviewCurrentPage(1);
    setSelectedFile(file);
    setDataFetched((prev) => !prev);
    // setDataFetched(false); // Reset data fetched status when selecting new file
    // setLoading(true); // Loading will be handled in the effect
    // Do not fetch data here

    setTimeout(() => {
      const previewSection = document.getElementById("previewSection");
      if (previewSection) {
        previewSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  // Add this function to handle search
  const handleSearch = (event) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);

    // Reset to first page when searching
    if (newSearchTerm !== searchTerm) {
      setPreviewCurrentPage(1);
    }
  };

  // Add this function to filter and paginate table data
  const getFilteredTableData = () => {
    if (!allData || allData.length === 0) return [];

    let filteredData = allData;
    console.log(filteredData, "allData");
    if (searchTerm.trim()) {
      // Define fields per tab
      const searchFields = {
        OFAC: ["ent_num", "sdn_name", "sdn_type"],
        NONSDN: ["ent_num", "sdn_name", "sdn_type"],
        UKSanctions: ["unique_id", "name", "type"],
        PEP: ["name"], // partial
        "Watch List": ["name"], // partial
        Negative: ["name", "file_type"], // exact
      };
      const currentTab = tabsData[selectedTab];
      const currentTabFields = searchFields[currentTab];

      filteredData = allData.filter((row) => {
        return Object.entries(row).some(([key, value]) => {
          if (!value) return false;
          const lowerKey = key.toLowerCase();
          const lowerValue = value.toString().toLowerCase();
          const lowerSearch = searchTerm.toLowerCase();

          // Normalize both sides
          const normalizedValue = lowerValue.trim().replace(/\s+/g, " ");
          const normalizedSearch = lowerSearch.trim().replace(/\s+/g, " ");

          // If tab has defined searchable fields
          if (currentTabFields && currentTabFields.includes(lowerKey)) {
            switch (currentTab) {
              // OFAC & NONSDN — exact for ent_num/sdn_type, partial for sdn_name
              case "OFAC":
              case "NONSDN":
                if (lowerKey === "sdn_name") {
                  return normalizedValue.includes(normalizedSearch); // partial
                } else {
                  return normalizedValue === normalizedSearch; // exact
                }

              // UKSanctions — exact for unique_id/type, partial for name
              case "UKSanctions":
                if (lowerKey === "name") {
                  return normalizedValue.includes(normalizedSearch); // partial
                } else {
                  return normalizedValue === normalizedSearch; // exact
                }

              // PEP & Watch List — partial (name only)
              case "PEP":
              case "Watch List":
                // return normalizedValue.includes(normalizedSearch);
                if (lowerKey === "name") {
                  return normalizedValue.includes(normalizedSearch); // partial
                } else {
                  return normalizedValue === normalizedSearch; // exact
                }
              // Negative — exact (file_type)
              case "Negative":
                // return normalizedValue === normalizedSearch;
                if (lowerKey === "name") {
                  return normalizedValue.includes(normalizedSearch); // partial
                } else {
                  return normalizedValue === normalizedSearch; // exact
                }

              default:
                // fallback: partial search for any mapped field
                return normalizedValue.includes(normalizedSearch);
            }
          }

          // Fallback for tabs without defined fields → partial across all
          if (!currentTabFields) {
            return normalizedValue.includes(normalizedSearch);
          }

          return false;
        });
      });
    }

    // Apply sorting if sortConfig is set
    if (sortConfig.key) {
      filteredData = [...filteredData].sort((a, b) => {
        // Get the value from row, try multiple key formats
        const getValue = (row, key) => {
          // Special handling for TYPE column (Negative case uses file_type)
          if (key === "TYPE") {
            return (
              row["type"] || 
              row["file_type"] || 
              row["FILE_TYPE"] || 
              ""
            );
          }
          // For other keys, try multiple formats
          return (
            row[key.toLowerCase()] || 
            row[key] || 
            row[key.toUpperCase()] || 
            ""
          );
        };

        const aValue = getValue(a, sortConfig.key);
        const bValue = getValue(b, sortConfig.key);

        // Handle numeric values
        const aNum = parseFloat(aValue);
        const bNum = parseFloat(bValue);
        const isNumeric =
          !isNaN(aNum) && !isNaN(bNum) && isFinite(aNum) && isFinite(bNum);

        let comparison = 0;

        if (isNumeric) {
          comparison = aNum - bNum;
        } else {
          // String comparison
          const aStr = String(aValue || "").toLowerCase();
          const bStr = String(bValue || "").toLowerCase();
          comparison = aStr.localeCompare(bStr);
        }

        return sortConfig.direction === "asc" ? comparison : -comparison;
      });
    }

    // Pagination
    const startIndex = (previewCurrentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  // Add function to render sort icon (add this helper function)
  const renderSortIcon = (columnKey) => {
    const normalizedKey = columnKey.toUpperCase().replace(/\s+/g, "_");
    const sortableFields = getSortableFields();

    if (!sortableFields.includes(normalizedKey)) {
      return null;
    }

    const isActive = sortConfig.key === normalizedKey;
    const isAsc = sortConfig.direction === "asc";

    if (!isActive) return <FaSort className="sort-icon inactive" />;

    return isAsc ? (
      <FaSortUp className="sort-icon active" />
    ) : (
      <FaSortDown className="sort-icon active" />
    );
  };

  // Add pagination functions for preview tables
  const handlePreviewFirstPage = () => {
    setPreviewCurrentPage(1);
  };

  const handlePreviewLastPage = () => {
    setPreviewCurrentPage(Math.ceil(previewTotalItems / itemsPerPage));
  };

  const handlePreviewPrevPage = () => {
    setPreviewCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handlePreviewNextPage = () => {
    setPreviewCurrentPage((prev) =>
      Math.min(prev + 1, Math.ceil(previewTotalItems / itemsPerPage))
    );
  };

  // Add modal view file handler
  const handleModalViewFile = (file) => {
    setModalSelectedFile(file);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  // Preview Table Api response fetch function
  const fetchData = async () => {
    try {
      // setLoading(true);

      const selectedFileType = selectedFile.fileType;
      const effectiveFileType =
        selectedFileType === "OFAC_ADD_SDN" ||
        selectedFileType === "OFAC_ADD_NON_SDN"
          ? selectedFileType
          : tabsData[selectedTab] === "OFAC"
          ? "OFAC_SDN"
          : tabsData[selectedTab] === "NONSDN"
          ? "OFAC_NON_SDN"
          : tabsData[selectedTab] === "UKSanctions"
          ? "UK_Sanctions"
          : tabsData[selectedTab] === "Negative"
          ? "Others"
          : tabsData[selectedTab] === "Watch List"
          ? "WATCH_LIST"
          : tabsData[selectedTab] === "PEP"
          ? "PEP"
          : tabsData[selectedTab] === "Address"
          ? addressFileType || ""
          : tabsData[selectedTab];

      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });

      // Fetch all data at once for frontend pagination
      const response = await getImportedData({
        file_type: effectiveFileType,
        file_name: selectedFile.file_name,
        bank_code: localStorage.getItem("bank_code") || "",
        page: 1,
        pageSize: 10000, // Large page size to get all data
        searchTerm: "", // No search term for initial fetch
      });
      Swal.close();
      if (response && response.status === "S" && response.result_info) {
        // Store all data for frontend pagination
        setAllData(response.result_info);
        setPreviewTotalItems(response.result_info.length);
        setPreviewCurrentPage(1); // Reset to first page
        setDataFetched(true); // Mark data as successfully fetched
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateSubmit = async () => {
    if (tabsData[selectedTab] === "Negative") {
      if (!fileType?.trim()) {
        Swal.fire({
          text: "Please Select a Type",
          icon: "warning",
          showConfirmButton: true,
          heightAuto: false,
        });
        return;
      }
    }

    // 1. Validate required name
    if (!name?.trim()) {
      Swal.fire({
        text: "Please enter a name",
        icon: "warning",
        showConfirmButton: true,
        heightAuto: false,
      });
      return;
    }
    let file_type = "";
    if (tabsData[selectedTab] === "Watch List") {
      file_type = "WATCH_LIST";
    } else if (tabsData[selectedTab] === "PEP") {
      file_type = "PEP";
    } else if (tabsData[selectedTab] === "Negative") {
      file_type = fileType;
    }
    if (!file_type?.trim()) {
      Swal.fire({
        text: "Please Select a Type",
        icon: "warning",
        showConfirmButton: true,
        heightAuto: false,
      });
      return;
    }
    // 2. Build payload
    const bank_code = localStorage.getItem("bank_code") || "";
    const correl_id = localStorage.getItem("correl_id") || "";
    const payload = {
      name: name.trim(),
      file_type: file_type,
      bank_code,
      correl_id,
    };

    console.log("Creating watch list with payload:", payload);

    // 3. Show loader while creating
    Swal.fire({
      html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
      showConfirmButton: false,
      heightAuto: false,
      customClass: { popup: "loader-swal" },
      allowOutsideClick: false,
    });

    // 4. Call API
    const response = await createImport(payload);

    // 5. Close loader
    Swal.close();

    // 6. Handle responses
    if (response.status === "S" && response.result_code === 200) {
      // Success alert
      Swal.fire({
        text: " Created successfully!",
        icon: "success",
        showConfirmButton: false, 
        timer: 1500,
        heightAuto: false,
      }).then(() => {
        // Reset modal state
        setName(""); // clear the name input
        setModalType([]); // reset modal selections (if any)
        // reset any other modal text state
        setModalOpen(false); // close modal

        // refresh / reload page data
        setReload((prev) => !prev);

        // re-fetch data if needed
        if (selectedFile) {
          fetchData(); // fetch new data after creation (unchanged from your original)
        }
      });
    } else if (
      response.status === "F" &&
      (response.message === "Unauthorized - Missing token" ||
        response.message === "Unauthorized - Invalid token")
    ) {
      Swal.fire({
        text: "Please login with your credentials",
        icon: "warning",
        showConfirmButton: false,
        timer: 3000,
      }).then(() => {
        localStorage.clear();
        navigate("/login");
      });
    } else {
      Swal.fire({
        title: "Error",
        text: response.message || "Failed to create watch list",
        icon: "error",
        showConfirmButton: true,
        heightAuto: false,
      });
    }
  };

  useEffect(() => {
    // Only fetch if selectedFile is set
    if (selectedFile) {
      fetchData();
    }
  }, [selectedFile, selectedTab]);

  // Add a useEffect to clear searchTerm when selectedTab changes
  useEffect(() => {
    setSearchTerm("");
    setPreviewCurrentPage(1); // Reset to first page when tab changes
    setDataFetched(false); // Reset data fetched status when tab changes
    setSortConfig({ key: null, direction: "asc" }); // Reset sorting when tab changes
  }, [selectedTab]);

  // Add a useEffect to update total items count when search or data changes
  const getFilteredDataLength = () => {
    if (!allData) return 0;

    let filtered = allData;

    if (searchTerm.trim()) {
      const currentTab = tabsData[selectedTab];

      const searchFields = {
        OFAC: ["ent_num", "sdn_name", "sdn_type"],
        NONSDN: ["ent_num", "sdn_name", "sdn_type"],
        UKSanctions: ["unique_id", "name", "type"],
        PEP: ["name"],
        "Watch List": ["name"],
        Negative: ["name", "file_type"],
      };

      const allowed = searchFields[currentTab] || [];

      filtered = allData.filter((row) =>
        Object.entries(row).some(([key, val]) => {
          if (!val) return false;
          if (!allowed.includes(key.toLowerCase())) return false;

          return val
            .toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
        })
      );
    }
    return filtered.length;
  };

  // useEffct for updating the Pagination
  useEffect(() => {
    const count = getFilteredDataLength();
    setPreviewTotalItems(count);

    const totalPages = Math.max(1, Math.ceil(count / itemsPerPage));
    if (previewCurrentPage > totalPages) {
      setPreviewCurrentPage(1);
    }
  }, [searchTerm, allData, selectedTab, sortConfig]);

  return (
    <div className="home-page">
      <div className="page-container">
        {/* Horizontal Scrolling Tabs - replaced Box with Bootstrap row */}
        <div
          className="row border-bottom mb-3"
          style={{ borderColor: "#dee2e6" }}
        >
          <div className="col-12">
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="reference data tabs"
              sx={{
                "& .MuiTabs-indicator": { display: "none" },
                "& .MuiTab-root": {
                  color: "rgba(0, 0, 0, 0.6)",
                  backgroundColor: "#ccc",
                  padding: "15px",
                  borderRadius: "4px 4px 0 0",
                  marginRight: "5px",
                  "&.Mui-selected": {
                    backgroundColor: "var(--theme-color)",
                    color: "white",
                    borderRadius: "4px 4px 0 0",
                  },
                },
              }}
            >
              {tabsData.map((tab, index) => (
                <Tab key={index} label={tabDisplayLabels[tab]} />
              ))}
            </Tabs>
          </div>
        </div>
        <div className="row align-items-end justify-content-between mb-4">
          {/* Left group: View Files + Sub File Type (Address only) */}
          <div className="col-12 col-lg d-flex flex-wrap align-items-center gap-3">
            <button
              type="button"
              className="anchor-button"
              onClick={() => setViewFilesModal(true)}
            >
              View Files
            </button>

            {tabsData[selectedTab] === "Address" && (
              <Tabs
                value={addressFileType}
                onChange={(e, val) => {
                  setAddressFileType(val);
                  setSelectedFile(null);
                  setPreviewTableData([]);
                  setPreviewCurrentPage(1);
                }}
                aria-label="Address subtype tabs"
                sx={{
                  minHeight: 40,
                  mb: 0, // shorthand for marginBottom: 0
                  p: 0,
                  "& .MuiTabs-indicator": {
                    backgroundColor: "var(--theme-color)",
                    height: 3,
                  },
                  "& .MuiTab-root": {
                    minHeight: 40,
                    textTransform: "none",
                    padding: "6px 16px",
                  },
                }}
              >
                <Tab label="SDN" value="OFAC_ADD_SDN" />
                <Tab label="NON SDN" value="OFAC_ADD_NON_SDN" />
              </Tabs>
            )}
          </div>

          {/* Right group: Import + Create */}
          <div className="col-12 col-lg-auto text-lg-end mt-3 mt-lg-0">
            {(tabsData[selectedTab] === "Watch List" ||
              tabsData[selectedTab] === "PEP" ||
              tabsData[selectedTab] === "Negative") && (
              <button
                type="button"
                className="btn cancelButton me-2"
                onClick={handleOpenModal}
              >
                + Create
              </button>
            )}

            {tabsData[selectedTab] !== "Manual Create" && (
              <button
                type="button"
                className="btn createButton"
                onClick={handleRawDataImportModal}
              >
                Import
              </button>
            )}
          </div>
        </div>

        {/* Upload Modal */}
        {rawDataImportModal && (
          <FileUploadModal
            selectedTab={selectedTab}
            fileInputs={fileInputs}
            handleFileChange={handleFileChange}
            handleClose={handleRawDataImportModal}
            tabsData={tabsData}
            setReload={setReload}
            onFileUploadSuccess={() => {
              // Close preview section when a new file is uploaded
              setSelectedFile(null);
              setPreviewTableData([]);
              setPreviewCurrentPage(1);
            }}
            onFileTypeChange={(fileType) => {
              if (tabsData[selectedTab] === "Address") {
                setAddressFileType(fileType);
              }
            }}
          />
        )}
        {/* Files Table */}
        {tabsData[selectedTab] === "OFAC" && (
          <OFACTab
            reload={reload}
            data={submittedData[tabsData[selectedTab]]}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            selectedTab={tabsData[selectedTab]}
            onViewFile={handleViewFile}
            onDeleteFile={handleDeleteFile}
            handleFileChange={handleFileChange}
          />
        )}
        {/* UK Sanctions tab */}
        {tabsData[selectedTab] === "UKSanctions" && (
          <UKSanctionsTab
            reload={reload}
            data={submittedData[tabsData[selectedTab]]}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            selectedTab={tabsData[selectedTab]}
            onViewFile={handleViewFile}
            onDeleteFile={handleDeleteFile}
          />
        )}
        {/* NON SDN tab */}
        {tabsData[selectedTab] === "NONSDN" && (
          <NonSDNTab
            reload={reload}
            data={submittedData[tabsData[selectedTab]]}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            selectedTab={tabsData[selectedTab]}
            onViewFile={handleViewFile}
            onDeleteFile={handleDeleteFile}
          />
        )}
        {/* Negative tab */}
        {tabsData[selectedTab] === "Negative" && (
          <OthersTab
            reload={reload}
            data={submittedData[tabsData[selectedTab]]}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            selectedTab={tabsData[selectedTab]}
            onViewFile={handleViewFile}
            onDeleteFile={handleDeleteFile}
          />
        )}
        {/* Address tab */}
        {tabsData[selectedTab] === "Address" && (
          <AddressTab
            reload={reload}
            data={submittedData[tabsData[selectedTab]]}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            selectedTab={tabsData[selectedTab]}
            onViewFile={handleViewFile}
            onDeleteFile={handleDeleteFile}
            selectedFileType={addressFileType}
          />
        )}
        {/* PEP tab */}
        {tabsData[selectedTab] === "PEP" && (
          <PEPTab
            reload={reload}
            data={submittedData[tabsData[selectedTab]]}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            selectedTab={tabsData[selectedTab]}
            onViewFile={handleViewFile}
            onDeleteFile={handleDeleteFile}
          />
        )}
        {/* Watch List tab */}
        {tabsData[selectedTab] === "Watch List" && (
          <WatchListTab
            reload={reload}
            data={submittedData[tabsData[selectedTab]]}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            selectedTab={tabsData[selectedTab]}
            onViewFile={handleViewFile}
            onDeleteFile={handleDeleteFile}
          />
        )}
        {/* main page file preview - click on view button */}
        {loading ? (
          <div className="text-center py-4">
            {/* <img src={require("../../assets/loader.gif")} alt="Loading..." style={{ width: "50px" }} />
            <p className="mt-2">Loading preview data...</p> */}
          </div>
        ) : (
          selectedFile &&
          dataFetched && (
            <div id="previewSection" className="mt-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="mb-0">Preview</h3>
                <button
                  className="btn createButton mx-1"
                  onClick={() => {
                    setSelectedFile(null);
                    setDataFetched(false);
                  }}
                >
                  Hide Preview
                </button>
              </div>
              <div className="row mb-3 justify-content-between">
                <div className="col-md-4">
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearch}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MdSearch />
                        </InputAdornment>
                      ),
                      endAdornment: searchTerm && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSearchTerm("");
                              setPreviewCurrentPage(1);
                            }}
                            edge="end"
                          >
                            <CloseIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="table-responsive">
                <table
                  className="table table-bordered table-striped mt-2"
                  id="fileTable"
                >
                  <thead className="table-dark">
                    <tr>
                      {getTableHeaders().map((header) => {
                        const normalizedKey = header
                          .toUpperCase()
                          .replace(/\s+/g, "_");
                        const sortableFields = getSortableFields();
                        const isSortable =
                          sortableFields.includes(normalizedKey);

                        return (
                          <th
                            className="sortable-header"
                            key={header}
                            scope="col"
                            onClick={() =>
                              isSortable && handleSort(normalizedKey)
                            }
                            style={{
                              cursor: isSortable ? "pointer" : "default",
                              userSelect: "none",
                              position: "relative",
                            }}
                          >
                            {header.replace(/_/g, " ")}
                            {isSortable && renderSortIcon(normalizedKey)}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  <tbody>
                    {getFilteredTableData().length === 0 ? (
                      <tr>
                        <td
                          colSpan={getTableHeaders().length}
                          className="text-center"
                        >
                          No records found
                        </td>
                      </tr>
                    ) : (
                      getFilteredTableData().map((row, index) => (
                        <tr key={row.id || index}>
                          <td>
                            {(previewCurrentPage - 1) * itemsPerPage +
                              index +
                              1}
                          </td>
                          {getTableHeaders()
                            .slice(1)
                            .map((header) => (
                              <td key={header}>

                                {/* {header === "LOAD_DATE"
                                  ? row[header.toLowerCase()]
                                    ? require("dayjs")(
                                        row[header.toLowerCase()]
                                      ).format("DD-MM-YYYY")
                                    : ""
                                  
                                  : row[header.toLowerCase()] ||
                                    row[header] ||
                                    ""} */}
                                    {(() => {
                                        const lowerKey = header.toLowerCase();                                    

                                        switch (header) {
                                          case "LOAD_DATE":
                                            return row[lowerKey]
                                              ? require("dayjs")(row[lowerKey]).format("DD-MM-YYYY")
                                              : "";
                                          case "TYPE":
                                            return row["type"] || row["FILE_TYPE"] || row["file_type"] || "";                                

                                          default:
                                            return row[lowerKey] || row[header] || "";
                                        }
                                      })()}
                              </td>
                            ))}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {previewTotalItems > 0 && (
                <div className="d-flex justify-content-end align-items-center mt-3">
                  <div className="pagination">
                    {/* {searchTerm.trim().length > 0 ? (
                   // Show search results info when searching
                   <span className="mx-2 align-self-center">
                     Showing {previewTotalItems} search results for "{searchTerm}" (Page {previewCurrentPage} of {Math.max(1, Math.ceil(previewTotalItems / itemsPerPage))})
                   </span>
                 ) : (
                   
                   
                 )} */}
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handlePreviewFirstPage}
                      disabled={previewCurrentPage === 1}
                      className="me-2"
                    >
                      First
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handlePreviewPrevPage}
                      disabled={previewCurrentPage === 1}
                      className="me-2"
                    >
                      Prev
                    </Button>
                    <span className="mx-2 align-self-center">
                      Page {previewCurrentPage} of{" "}
                      {Math.max(1, Math.ceil(previewTotalItems / itemsPerPage))}
                    </span>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handlePreviewNextPage}
                      disabled={
                        previewCurrentPage ===
                          Math.ceil(previewTotalItems / itemsPerPage) ||
                        previewTotalItems === 0
                      }
                      className="me-2"
                    >
                      Next
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handlePreviewLastPage}
                      disabled={
                        previewCurrentPage ===
                          Math.ceil(previewTotalItems / itemsPerPage) ||
                        previewTotalItems === 0
                      }
                    >
                      Last
                    </Button>
                  </div>
                </div>
              )}
            </div>
          )
        )}
        {/* Add the View Files Modal */}
        {viewFilesModal && (
          <ViewFilesTable
            viewFilesModal={viewFilesModal}
            onClose={() => setViewFilesModal(false)}
            onViewFile={(file) => {
              setModalSelectedFile(file);
              handleModalViewFile(file);
            }}
            selectedTab={selectedTab} // Pass the tab index, not the label
            fileType={tabsData[selectedTab]}
            addressFileType={addressFileType}
          />
        )}
      </div>
      {/* For others tab - create related modal */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>
          {tabsData[selectedTab] === "Watch List" && "Create Watch List"}
          {tabsData[selectedTab] === "PEP" && "Create PEP"}
          {tabsData[selectedTab] === "Negative" && "Create Negative"}
        </DialogTitle>
        <DialogContent>
          {/* <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>File Type</div>
            <FormControl fullWidth size="small">
              <Select
                multiple
                value={modalType}
                onChange={(e) => setModalType(e.target.value)}
                renderValue={(selected) => selected.join(", ")}
              >
                {fileTypeOptions.map((type) => (
                  <MenuItem key={type} value={type}>
                    <Checkbox checked={modalType.indexOf(type) > -1} />
                    <ListItemText primary={type} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div> */}
          {/* {tabsData[selectedTab] === "Watch List" && setFileType("WATCH_LIST")}
          {tabsData[selectedTab] === "PEP" && setFileType("PEP")} */}
          {tabsData[selectedTab] === "Negative" && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontWeight: 500, marginBottom: 4 }}>Type</div>
              <FormControl fullWidth size="small">
                <Select value={fileType} onChange={handleChange} displayEmpty>
                  <MenuItem value="PC-LFM">PC-LFM</MenuItem>
                  <MenuItem value="WHITE_LIST">White List</MenuItem>
                  <MenuItem value="NC">Negative Case</MenuItem>
                </Select>
              </FormControl>
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>Name</div>
            <TextField
              fullWidth
              size="small"
              value={name}
              onChange={(e) => setName(e.target.value)}
              // placeholder="Enter name"
              autoComplete="off"
              inputProps={{ maxLength: 256 }}
            />
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            variant="outlined"
            onClick={() => {
              setName("");
              setModalOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            // disabled={modalType.length === 0 || !modalName.trim()}
            onClick={handleCreateSubmit}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ImportData;
